module.exports = __webpack_public_path__ + "img/2x.f9e72d4.jpg";